import Errors from '../../../Errors';
import { Loader } from '@googlemaps/js-api-loader';

export default {
    props: ['initialAddresses', 'initialDefaultAddress', 'countries'],

    async mounted() {

    },

    data() {
        return {
            addresses: this.initialAddresses,
            defaultAddress: this.initialDefaultAddress,
            form: {
                state: 'LIM',
                zip: 'Lima',
                country: 'PE',
                selected_district: null,
                selected_address_type: null,
                address_type: '',
                address_type_name: '',
                latitude: '',
                longitude: '',
                zone_name: '',
                zone_code: '',
                phone: '',
            },
            states: {},
            errors: new Errors(),
            formOpen: false,
            editing: false,
            loading: false,
            districts: [],
            addressTypes: [],
            map: null,
            marker: null,
            defaultLatitude: -12.0266034,
            defaultLongitude: -77.1278633,
        };
    },

    computed: {
        firstCountry() {
            return Object.keys(this.countries)[0];
        },

        hasAddress() {
            return Object.keys(this.addresses).length !== 0;
        },

        hasNoStates() {
            return Object.keys(this.states).length === 0;
        },
    },

    created() {
        this.changeCountry(this.firstCountry);

        this.fetchDistricts((districts) => {
            districts.map(district => {
                this.districts.push(district);
            });
        });

        this.fetchAddressTypes((addressTypes) => {
            addressTypes.map(type => this.addressTypes.push(type));
        });
    },

    methods: {
        changeDefaultAddress(address) {
            this.$set(this.defaultAddress, 'address_id', address.id);

            $.ajax({
                method: 'POST',
                url: route('account.change_default_address'),
                data: { address_id: address.id },
            }).then((message) => {
                this.$notify(message);
            }).catch((xhr) => {
                this.$notify(xhr.responseJSON.message);
            });
        },

        changeCountry(country) {
            this.form.country = country;
            // this.form.state = '';

            this.fetchStates(country);
        },

        fetchStates(country) {
            $.ajax({
                method: 'GET',
                url: route('countries.states.index', { code: country }),
            }).then((states) => {
                this.$set(this, 'states', states);
            });
        },

        edit(address) {
            this.formOpen = true;
            this.editing = true;
            this.form = address;

            this.districts.map(district => {
                if (district.value == address.zone_code) {
                    this.form.selected_district = district;
                }
            });

            this.addressTypes.map(type => {
                if (type.value == address.address_type) {
                    this.form.selected_address_type = type;
                }
            });

            this.fetchStates(address.country);

            this.defaultLatitude = parseFloat(address.latitude);
            this.defaultLongitude = parseFloat(address.longitude);

            this.loadMap();
        },

        newAddress(){
            this.formOpen = true
            this.loadMap();
        },

        remove(address) {
            if (!confirm(this.$trans('storefront::account.addresses.confirm'))) {
                return;
            }

            $.ajax({
                method: 'DELETE',
                url: route('account.addresses.destroy', address.id),
            }).then((response) => {
                this.$delete(this.addresses, address.id);
                this.$notify(response.message);
            }).catch((xhr) => {
                this.$notify(xhr.responseJSON.message);
            });
        },

        cancel() {
            this.editing = false;
            this.formOpen = false;

            this.errors.reset();
            this.resetForm();
        },

        save() {
            this.loading = true;

            if (this.editing) {
                this.update();
            } else {
                this.create();
            }
        },

        update() {
            $.ajax({
                method: 'PUT',
                url: route('account.addresses.update', { id: this.form.id }),
                data: this.form,
            }).then((response) => {
                this.formOpen = false;
                this.editing = false;

                this.addresses[this.form.id] = response.address;

                this.resetForm();
                this.$notify(response.message);
            }).catch((xhr) => {
                if (xhr.status === 422) {
                    this.errors.record(xhr.responseJSON.errors);
                }

                this.$notify(xhr.responseJSON.message);
            }).always(() => {
                this.loading = false;
            });
        },

        create() {
            $.ajax({
                method: 'POST',
                url: route('account.addresses.store'),
                data: this.form,
            }).then((response) => {
                this.formOpen = false;

                let address = { [response.address.id]: response.address };

                this.$set(this, 'addresses', { ...this.addresses, ...address });

                this.resetForm();
                this.$notify(response.message);
            }).catch((xhr) => {
                if (xhr.status === 422) {
                    this.errors.record(xhr.responseJSON.errors);
                }

                this.$notify(xhr.responseJSON.message);
            }).always(() => {
                this.loading = false;
            });
        },

        resetForm() {
            this.form = {
                state: 'LIM',
                zip: 'Lima',
                country: 'PE',
                selected_district: null,
                selected_address_type: null,
                address_type: '',
                address_type_name: '',
                latitude: '',
                longitude: '',
                zone_name: '',
                zone_code: '',
                phone: '',
            };
            this.defaultLatitude = -12.0266034;
            this.defaultLongitude = -77.1278633;
        },

        fetchDistricts(callback) {
            $.ajax({
                method: 'GET',
                url: route('districts.index'),
            }).then(callback);
        },

        fetchAddressTypes(callback) {
            $.ajax({
                method: 'GET',
                url: route('addresstypes.index'),
            }).then(callback);
        },

        changeShippingCity(city) {
            this.$set(this.form, 'city', this.form.selected_district.distrito);
            this.$set(this.form, 'zone_name', this.form.selected_district.name);
            this.$set(this.form, 'zone_code', this.form.selected_district.value);
            this.$set(this.form, 'map_address', `${this.form.address_1} ${this.form.city}`);
        },

        changeShippingAddressType(type) {
            this.$set(this.form, 'address_type', this.form.selected_address_type.value);
            this.$set(this.form, 'address_type_name', this.form.selected_address_type.name);
        },

        loadMap() {
            const loader = new Loader({
                apiKey: "AIzaSyBWZV8NrnsqNM8eh6llkewZsT4L4jzFFww",
                version: "weekly",
                libraries: ["places"]
            });

            const myLatLng = { lat: this.defaultLatitude, lng: this.defaultLongitude };
            const mapOptions = {
                center: myLatLng,
                zoom: 18,
                mapTypeControl: false,
                fullscreenControl: false,
            };

            loader
                .load()
                .then((google) => {
                    const mapContainer = this.$refs.googleMap
                    const card = this.$refs.mapCard
                    const input = this.$refs.mapInput
                    this.map = new google.maps.Map(mapContainer, mapOptions);
                    let vm = this;

                    this.marker = new google.maps.Marker({
                        position: myLatLng,
                        map: this.map,
                        draggable: true,
                        clickable: true,
                        animation: google.maps.Animation.DROP,
                    });

                    const options = {
                        fields: ["formatted_address", "geometry", "name"],
                        strictBounds: false,
                        types: ["establishment"],
                    };

                    this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(card);

                    const autocomplete = new google.maps.places.Autocomplete(input, options);

                    autocomplete.bindTo("bounds", this.map);

                    const infowindow = new google.maps.InfoWindow();
                    const infowindowContent = this.$refs.mapInfoWindow;
                    infowindow.setContent(infowindowContent);

                    autocomplete.addListener("place_changed", () => {
                        infowindow.close();
                        this.marker.setVisible(false);

                        const place = autocomplete.getPlace();

                        if (!place.geometry || !place.geometry.location) {
                            window.alert("No details available for input: '" + place.name + "'");
                            return;
                        }

                        if (place.geometry.viewport) {
                            this.map.fitBounds(place.geometry.viewport);
                        } else {
                            this.map.setCenter(place.geometry.location);
                            this.map.setZoom(17);
                        }

                        this.marker.setPosition(place.geometry.location);
                        this.marker.setVisible(true);
                        infowindowContent.children["place-name"].textContent = place.name;
                        infowindowContent.children["place-address"].textContent = place.formatted_address;
                        infowindow.open(this.map, this.marker);

                        this.form.latitude = place.geometry.location.lat();
                        this.form.longitude = place.geometry.location.lng();
                    });

                    google.maps.event.addListener(this.marker, 'dragend', function (marker) {
                        var latLng = marker.latLng;
                        vm.form.latitude = latLng.lat();
                        vm.form.longitude = latLng.lng();
                        var latlng = {
                            lat: latLng.lat(),
                            lng: latLng.lng(),
                        };
                        var geocoder = new google.maps.Geocoder;
                        geocoder.geocode({
                            'location': latlng
                        }, function (results, status) {
                            if (status === 'OK') {
                                if (results[0]) {
                                    input.value = results[0].formatted_address;
                                } else {
                                    window.alert('No results found');
                                }
                            } else {
                                window.alert('Geocoder failed due to: ' + status);
                            }
                        });
                    });
                })
                .catch(e => {
                    // do something
                });
        }
    },
};
